import { lazy } from "react";
import reloadOnceForChunkError from "../Utils/chunkReloadGuard";

const retry = (fn, retriesLeft = 2, interval = 1000) => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        if (reloadOnceForChunkError(error)) {
          reject(error);
          return;
        }
        if (retriesLeft === 1) {
          reject(error);
          return;
        }
        setTimeout(() => {
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};

const retryLazy = (fn) => lazy(() => retry(fn));

export default retryLazy;
